// extracted by mini-css-extract-plugin
export default {"wrapper":"EditSelectVertical_wrapper__uAGRb","selected":"EditSelectVertical_selected__2g39p"};